import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';

const stageConfig: PartialDeep<Configuration> = {
  services: {
    configEndpoint: 'https://dev.api.civic.com/cw-services-preprod/browser-configs',
    networkRetryConfig: {
      defaultRetries: 1,
      userControlledRetries: 1,
      retryTimeoutMs: {
        1: 1,
        2: 1,
        3: 1,
        4: 1,
      },
      maxAllowedRetryLoops: 1,
    },
    captchaKeys: {
      hCaptchaKey: '20000000-ffff-ffff-ffff-000000000002',
      // testing key: always returns score 1 with no challenge and no domain check
      reCaptchaKey: '6LfrZTYlAAAAAH6EUETaBNTuif8tXbU7lD5wsdDT',
    },
    validation: {
      // authEndpoint: 'https://d1uez1k2ao6q4u.cloudfront.net', // lambda@edge
      authEndpoint: 'https://dev.api.civic.com/sign-dev', // lambda
      validationEndpoint: 'https://dev.api.civic.com/pass-dev',
      pollingIntervalInSeconds: 1,
    },
    retention: {
      retentionEndpoint: 'http://localhost:3001/dev/retention',
    },
    gatekeeperFaceIdSearch: {
      endpoint: 'http://localhost:3001/dev/gatekeeperSearch',
    },
    uniqueness: {
      revocationPortalUrl: 'https://revoke-preprod.civic.com/uniqueness',
    },
    facetecProductionMode: false,
  },
};

export default stageConfig;
